import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { fetchDashboardUserSubscription } from "../../api/region";

const UsersBarChart = () => {
  const { filter } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);

  const fetchData = async () => {
    try {
      const colorMap = {
        Gold: "#916008",
        Luxury: "#E8E8E8",
        Free: "#0066FF", // you can use for nonSubscribed
      };
      const defaultColor = "#0066FF";
      setIsLoading(true);
      const data = await fetchDashboardUserSubscription(filter);
      const SubscriptionType = data.subscriptionCount.filter((item) => item._id !== null);
      const nonSubscribed = data.userCount;
      const options = {
        chart: {
          type: "column",
          height: 300,
        },
        title: {
          text: "Users",
          align: "high",
          rotation: 0,
          style: {
            color: "#3C4043",
            fontWeight: "500",
            fontSize: "20px",
            textAlign: "left",
            fontFamily: "Indivisible, sans-serif",
          },
        },
        xAxis: {
          categories: [...SubscriptionType.map((item) => item._id), "Non Subscribed"],
          title: {
            text: "",
          },
        },
        yAxis: {
          min: 0,
          enabled: false,
          title: {
            text: "",
            align: "high",
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            const category = this.point.category || this.x || "Unknown";
            return `<div style="font-weight:bold; font-size:16px; color:#000;">${category}</div>
            <div>Users: ${this.y}</div>`;
          },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderRadius: 5,
          borderWidth: 1,
          shadow: true,
        },

        plotOptions: {
          column: {
            borderRadius: 15,
            dataLabels: {
              enabled: false,
              format: "{point.y:,0f}",
            },
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            name: "Users",
            data: [...SubscriptionType.map((item) => item.count), nonSubscribed],
            colorByPoint: true,
            colors: [...SubscriptionType.map((item) => colorMap[item._id] || defaultColor), defaultColor],
          },
        ],
      };
      setOptions(options);
      setIsLoading(false);
    } catch (err) {
      console.error('Error while loading user data', err);
    }
  };
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);

  return (
    <Box sx={{ border: "1px solid #E8E8E8", p: 3, borderRadius: "12px", mb: 2 }}>
      {
        isLoading ? 
         <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                Loading...
              </Typography>
            </Box>
         : (options?.series?.[0]?.data?.reduce((num, d) => d+ num, 0) > 0
          ? <HighchartsReact highcharts={Highcharts} options={options} />
          : <Box>
            <Typography fontWeight={500} mb={2} sx={{ fontSize: '20px', color: '#3C4043' }}>
              Users
            </Typography>

            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                No data available
              </Typography>
            </Box>
          </Box> 
      )}
    </Box>
  );
};

export default UsersBarChart;
